/*

    Deprecated: use ./RadioButton.jsx

*/


import React from 'react'
import RadioButtonWrapper from './RadioButtonWrapper';

const RadioButton = ({
    field: { name, value, onChange, onBlur },
    id,
    props,
    label,
    className,
    checkedValue=null,
    editFlyerItem=false,
    itemId=null,
    submitFormFunc,
    setFieldValue
}) => {
    return (
        <RadioButtonWrapper id={id} label={label}>
            {editFlyerItem && props ? (
                <input
                    name={name}
                    id={id}
                    type="radio"
                    value={checkedValue}
                    checked={checkedValue === value}
                    onChange={(e) => {
                            props.handleChange(e)
                            setTimeout(props.submitForm, 0);
                    }}
                    className={'radio-button'}
                />
            ) : submitFormFunc ? (
                <input
                    name={name}
                    id={id}
                    type="radio"
                    value={id}
                    checked={id === value}
                    onChange={(e) => {
                        onChange(e)
                        submitFormFunc()
                    }}
                    onBlur={onBlur}
                    className={'radio-button'}
                />
            ) : (
                <input
                    name={name}
                    id={id}
                    type="radio"
                    value={id}
                    checked={id === value}
                    onChange={(e) => {
                        onChange(e)
                        setFieldValue('filterType', '')
                        setFieldValue('filterValue', '')
                    }}
                    onBlur={onBlur}
                    className={'radio-button'}
                />
            )}
        </RadioButtonWrapper>
        // <div className="control-radio-wrapper">
        //     <label className="control control-radio" htmlFor={id}>{label}
        //         {editFlyerItem && props ? (
        //             <input
        //                 name={name}
        //                 id={id}
        //                 type="radio"
        //                 value={checkedValue}
        //                 checked={checkedValue === value}
        //                 onChange={props.handleChange}  
        //                 onChange={(e) => {
        //                         props.handleChange(e)
        //                         setTimeout(props.submitForm, 0);
        //                 }}
        //                 className={'radio-button'}
        //             />
        //             ) : (
        //             <input
        //                 name={name}
        //                 id={id}
        //                 type="radio"
        //                 value={id}
        //                 checked={id === value}
        //                 onChange={(e) => {
        //                     onChange(e)
        //                     setFieldValue('filterType', '')
        //                     setFieldValue('filterValue', '')
        //                 }}
        //                 onBlur={onBlur}
        //                 className={'radio-button'}
        //             />
        //         )}
        //         <div className="control_indicator"></div>
        //     </label>
        // </div>
    )
}

export default RadioButton